export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return !!(
        ['D'].includes(amzSkuStatus) ||
        (applicationStatus && ['O', 'P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return !!(
        !['Q'].includes(amzSkuStatus) ||
        (applicationStatus && ['O', 'P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_copy_product') || '复制产品',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    divided: true,
    allow: 'C',
  },
  {
    text: '申请信息审核',
    icon: 'el-icon-circle-check',
    menuType: 'informationReview',
    divided: true,
    allow: 'I',
    disabled: ({ amzSkuStatus }) => {
      return !(amzSkuStatus == 'Q')
    },
  },
  {
    text: that.$l('btn_submission_for_order_placement') || '提交转可下单',
    icon: 'el-icon-check',
    menuType: 'purchasableApply',
    allow: 'U',
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return amzSkuStatus != 'C' ||
        (applicationStatus &&
          ['O', 'P'].includes(applicationStatus))
    },
  },
  // {
  //   text: '申请转正',
  //   icon: 'el-icon-circle-check',
  //   menuType: 'fullMemberApply',
  //   allow: 'F',
  //   disabled: ({ amzSkuStatus, applicationStatus }) => {
  //     return !!(
  //       ['Q', 'D', 'Y'].includes(amzSkuStatus) ||
  //       ['P'].includes(applicationStatus)
  //     )
  //   },
  // },
  {
    text: that.$l('btn_edit_image') || '编辑图片',
    icon: 'el-icon-picture-outline',
    menuType: 'editImage',
    divided: true,
    allow: 'H',
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return !!(
        ['D'].includes(amzSkuStatus) ||
        (applicationStatus && ['O', 'P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('INDEX.btn_print_tag') || '标签打印',
    icon: 'el-icon-printer',
    menuType: 'print',
    divided: true,
    allow: 'P',
    disabled: ({ amzSkuStatus }) => !['Y'].includes(amzSkuStatus),
  },
]
